import React from 'react';
import { Card } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import HighlightOff from '@material-ui/icons/HighlightOff';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Discrepancy extends React.Component {

  state = {
    discrepancy: [],
    open: false,
  }

  componentDidUpdate(props) {
    if (props.selectedBranch != this.props.selectedBranch) {
      this.getDiscrepancy();
    }
  }

  componentDidMount() {
    this.getDiscrepancy();
  }

  getDiscrepancy() {
      let context = this;
      let cook = (ReadCookie("vaigai"));
      let userId = cook.id;
      context.setState({
        load: true,
        message: 'Getting Discrepancy!!!'
      });

      let branch = this.props.selectedBranch;
      let data1 = { 'branch' : branch, 'userId': userId };
      $.ajax({
        type: 'POST',
        data: data1,
        url: Server() + 'stocktransfer/getdiscrepancy.php',
        success: function(data)
        {
          console.log(data);
          context.setState({
            load: false,
          });
          try {
            data = JSON.parse(data);
            for (var i = 0; i < data.length; i++) {
              let s = 1;
              data[i].sino = s + i;
            }
            context.setState({ discrepancy: data })
          } catch (e) {

          }
        },
        error: function(err)
        {

        }
      });
    }

    adjustShortage() {
      let context = this;
      let id = this.state.shortageId;
      let shortageqty = this.state.shortageqty;
      let shortagepartno = this.state.shortagepartno;
      let shortagebrand = this.state.shortagebrand;
      context.setState({
        load: true,
        message: 'Shortage Adjust!!!'
      });
      let branch = this.props.selectedBranch;
      let data1 = { 'id' : id, 'shortageqty': shortageqty, 'shortagepartno': shortagepartno,
                    'shortagebrand': shortagebrand, 'shortagebranch': branch };
      $.ajax({
        type: 'POST',
        data: data1,
        url: Server() + 'stocktransfer/shortageadjustment.php',
        success: function(data)
        {
          console.log(data);
          context.setState({
            load: false,
          });
          if (data == 1) {
            let datas = context.state.discrepancy;
            datas.map((x) => {
              if (x.id == id) {
                x.status = 1;
              }
            })
            context.setState({ discrepancy: datas, open: false })
          }
        },
        error: function(err)
        {

        }
      });
    }

  render() {
    let { discrepancy } = this.state;
    return (
      <div style={{display: this.props.shortageview}}><br/>
      <Loading load={this.state.load} message={this.state.message} />
        { (discrepancy) ?
          (
            <div>
              <table width='100%' id='table'>
                <tr>
                  <th id='tableheader'><center>SiNo</center></th>
                  <th id='tableheader'><center>Id</center></th>
                  <th id='tableheader' style={{width: '11%'}}><center>Date</center></th>
                  <th id='tableheader'><center>From Branch</center></th>
                  <th id='tableheader'><center>Spare</center></th>
                  <th id='tableheader'><center>Shortage</center></th>
                  <th id='tableheader'><center>Value</center></th>
                  {/* <th id='tableheader' style={{display: this.props.shortageedit}}><center>Adj..</center></th> */}
                </tr>
                { discrepancy.map((z) => {
                  let date = z.timestamp.split(' ')[0];
                  let icon = (<CheckCircleOutline style={{color: 'green'}} />);
                  if (z.status == 0 || z.status == '0') {
                    icon = (<HighlightOff style={{color: 'red'}}
                      onClick={ () => {
                        this.setState({
                          open: true,
                          shortageId: z.id,
                          shortagepartno: z.partno,
                          shortagebrand: z.brand_id,
                          shortageqty: z.discrepancy
                         }) } } />);
                  }
                  return (
                    <tr>
                      <td><center>{z.sino}</center></td>
                      <td><center>{z.id}</center></td>
                      <td><center>{date}</center></td>
                      <td><center>{z.branch_name}</center></td>
                      <td><center>{z.partno+'->'+z.spare_name}</center></td>
                      <td><center>{z.discrepancy}</center></td>
                      <td><center>Rs.{z.amount}</center></td>
                      {/* <td style={{cursor: 'pointer', display: 'this.props.shortageedit'}}><center>{icon}</center></td> */}
                    </tr>
                  )}
                )}
              </table>
            </div>
          ) :
          (
            <div></div>
          )
        }
        <Dialog open={this.state.open} onClick={ () => { this.setState({ open: false }) }} aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"ALERT"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Conform your Adjustment!!!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">
              Cancel
            </Button>
            <Button onClick={this.adjustShortage.bind(this)} color="primary" autoFocus>
              Conform
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Discrepancy;
